import { Box, Button, Loader, Text } from '@acast/decibel';
import T from 'prop-types';
import React from 'react';
import { markerPropType } from '../../../../customPropTypes';
import { MARKER_TYPES, validateMarker } from '../../../../shared/helpers/markers';
import AdForm from './components/forms/ad';
import ImageForm from './components/forms/image';
import LinkForm from './components/forms/link';
import UnspecifiedForm from './components/forms/unspecified';
import VideoForm from './components/forms/video';
import ValidationErrors from './components/validation-errors';

class MarkerSettings extends React.Component {
  getMarkerTitle = () => {
    const { marker } = this.props;

    if (marker.type === MARKER_TYPES.AD) {
      return {
        preroll: 'Pre-Roll',
        midroll: 'Mid-Roll',
        postroll: 'Post-Roll',
      }[marker.body.placement];
    }

    return (
      {
        [MARKER_TYPES.IMAGE]: 'Image Marker',
        [MARKER_TYPES.LINK]: 'Link Marker',
        [MARKER_TYPES.VIDEO]: 'Video Marker',
      }[marker.type] || 'Unspecified Marker'
    );
  };

  handleChange = field => value => {
    const { onUpdateMarker, marker } = this.props;
    const data = {};

    if (['linkurl', 'videourl'].includes(field)) {
      data.body = { [field]: value };
    } else if (field === 'image') {
      data.thumbnail = { ...marker.thumbnail, original: value };
    } else {
      data[field] = value;
    }

    onUpdateMarker(marker.episode, marker.id, data);
  };

  handleDelete = () => {
    this.props.onDeleteMarker(this.props.marker);
  };

  render() {
    const { markers, markerId, episodeDuration, silenceDetected } = this.props;

    const marker = markers.find(m => m.id === markerId);

    if (!marker || !episodeDuration) {
      return (
        <Box mt={8} justifyContent="center">
          <Loader />
        </Box>
      );
    }

    const FormComponent =
      {
        [MARKER_TYPES.AD]: AdForm,
        [MARKER_TYPES.IMAGE]: ImageForm,
        [MARKER_TYPES.LINK]: LinkForm,
        [MARKER_TYPES.VIDEO]: VideoForm,
      }[marker.type] || UnspecifiedForm;
    const errors = validateMarker(marker);
    const title = this.getMarkerTitle();

    return (
      <div className="marker-settings">
        <Text variant="h3">{title}</Text>
        <Box mb={4} flexDirection="column">
          <ValidationErrors errors={errors} />
        </Box>
        <FormComponent
          episodeDuration={episodeDuration}
          errors={errors}
          marker={marker}
          markers={markers}
          onUpdateMarker={this.handleChange}
          silenceDetected={silenceDetected}
        />
        {marker.type !== MARKER_TYPES.AD && (
          <Box mt={6}>
            <Button variant="primary" intent="danger" onClick={this.handleDelete}>
              Remove Marker
            </Button>
          </Box>
        )}
      </div>
    );
  }
}

MarkerSettings.propTypes = {
  episodeDuration: T.number,
  marker: markerPropType,
  markerId: T.string,
  markers: T.arrayOf(markerPropType),
  onDeleteMarker: T.func.isRequired,
  onUpdateMarker: T.func.isRequired,
  silenceDetected: T.arrayOf(
    T.shape({
      duration: T.number,
      end: T.number,
    })
  ),
};

MarkerSettings.defaultProps = {
  episodeDuration: undefined,
  marker: undefined,
  markerId: undefined,
  markers: [],
};

export default MarkerSettings;
